import { Fragment, useEffect } from "react";

import { useHistory } from "react-router-dom";

import EditIcon from "@material-ui/icons/Edit";
import { Box, Typography } from "@material-ui/core";

import { useNewSubscriberContext } from "../../Context/NewSubsciberContext";
import {
  setDistrict,
  setStatusBackToSummary,
} from "../../Context/NewSubscriberAction";
import { getDetailsFromPincode } from "../../../../../store/actions";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { SUCCESS_RESPONSE_CODE } from "..";

const IDENTIFIER_MAP = {
  150: <p>eAadhaar</p>,
  119: <p>PAN</p>,
  372: <p>cKYC</p>,
};

const labelText = {
  fontSize: "14px",
  fontWeight: 400,
  color: "#002856",
  lineHeight: "16px",
};

const bodyText = {
  fontSize: "14px",
  fontWeight: 400,
  color: "#000000",
  lineHeight: "16px",
};

const KycDetailsPreview = () => {
  // const { kycDetailsPreview = {} } = useSelector(
  //   (state) => state.newSubscriber.preview
  // );
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    kycDetails: kycDetailsPreview,
    pan,
    EKYCDetails,
    dispatch: contextDispatch,
    summary,
    fatcaDetails,
  } = useNewSubscriberContext();
  const {
    Address1 = "-",
    Address2 = "-",
    PinCode = "-",
    IdentifierType,
    State,
    IdentifierNum,
    PANNumber,
    District,
    CountryNameDes,
  } = kycDetailsPreview?.data || summary?.data?.objKYCDetails[0];
  const EKYCdata = EKYCDetails?.data?.result?.PERSONAL_DETAILS || {};

  // const kycDetailsData = kycDetailsPreview.data

  const [pincodeDetails, setPincodeDetails] = useState();

  useEffect(() => {
    async function fetchStateValue(pincode) {
      const response = await dispatch(getDetailsFromPincode({ pincode }));
      if (Number(response.statusCode) === SUCCESS_RESPONSE_CODE) {
        const { data } = response;
        setPincodeDetails(data[0]);
        contextDispatch(setDistrict(data[0]?.District));
      }
    }

    fatcaDetails?.data?.ListFatcaDetails[0]?.PinCode &&
      fetchStateValue(fatcaDetails?.data?.ListFatcaDetails[0]?.PinCode);
  }, []);

  const back = () => {
    contextDispatch(setStatusBackToSummary(true));
    history.push({
      pathname: "/nps/AddSubs/fatca-details",
    });
  };

  return (
    <Fragment>
      <div className="new-subscriber-container">
        <div
          style={{
            paddingLeft: "16px",
            fontSize: "18px",
            color: "#000000",
            fontWeight: "400",
            opacity: "0.8",
            paddingBottom: "4px",
          }}
        >
          KYC/FATCA DETAILS
        </div>
        <EditIcon onClick={back} className="cursor" />
      </div>
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gridRowGap: "2rem",
          padding: "20px 10px 20px 6px",
          margin: "0px 10px 20px 50px",
        }}
      >
        {IDENTIFIER_MAP[Number(IdentifierType)] ? (
          <div>
            <Typography style={labelText}>Registration Mode</Typography>
            <Typography style={bodyText}>
              {IDENTIFIER_MAP[Number(IdentifierType)] || null}
            </Typography>
          </div>
        ) : null}
        <div>
          <Typography style={labelText}>PAN No</Typography>
          <Typography style={bodyText}>
            {EKYCdata?.PAN || pan || PANNumber || IdentifierNum}
          </Typography>
        </div>
        <div>
          <Typography style={labelText}>Address</Typography>
          <Typography style={bodyText}>
            {fatcaDetails?.data?.ListFatcaDetails[0]?.Address ||
              getAddress(EKYCdata, Address1, Address2)}
          </Typography>
        </div>
        <div>
          <Typography style={labelText}>Pincode</Typography>
          <Typography style={bodyText}>
            {fatcaDetails?.data.ListFatcaDetails[0]?.PinCode ||
              EKYCdata?.PERM_PIN ||
              PinCode}
          </Typography>
        </div>
        <div>
          <Typography style={labelText}>Country</Typography>
          <Typography style={bodyText}>
            {fatcaDetails?.data?.ListFatcaDetails[0]?.CountryName ||
              EKYCdata?.PERM_COUNTRY ||
              CountryNameDes}
          </Typography>
        </div>
        <div>
          <Typography style={labelText}>State/UT</Typography>
          <Typography style={bodyText}>
            {pincodeDetails?.StateN || EKYCdata?.PERM_STATE || State}
          </Typography>
        </div>
        <div>
          <Typography style={labelText}>District</Typography>
          <Typography style={bodyText}>
            {pincodeDetails?.District || EKYCdata?.PERM_DIST || District}
          </Typography>
        </div>
      </Box>
    </Fragment>
  );
};
export default KycDetailsPreview;

const getAddress = (EKYCdata, Address1, Address2) => {
  if (EKYCdata?.PERM_LINE1 && EKYCdata?.PERM_LINE2) {
    return <>{`${EKYCdata?.PERM_LINE1} ${EKYCdata?.PERM_LINE2}`}</>;
  }

  return <>{`${Address1} ${Address2}`}</>;
};
